import React from 'react';
import Select from 'react-select';

function SelectBox(props) {
  const customStyles = {
    control: (base) => ({
      ...base,
      border: '1px solid #A2ABBA',
      boxShadow: 'none',
      minHeight: props.height,
      height: props.height || '40px',
      background: '#F4F4F5',
      borderRadius: '4px',
      fontSize: '0.875rem',
      width: 'max-content',
      minWidth: '100%',
      outline: 'none',
      '&:hover': {
        border: '1px solid #A2ABBA'
      }
    }),
    menu: (provided) => ({
      ...provided,
      zIndex: 9999,

      background: '#F4F4F5'
    }),
    input: (provided) => ({
      ...provided,
      height: '9px',
      paddingLeft: '220px',
      background: '#F4F4F5'
    })
  };

  const handleChange = (value, actionMeta) => {
    if (props?.switch) return props.onChange(value);
    else
      props?.formik
        ? props?.formik?.setFieldValue(props?.label, value)
        : props.onChange(value);
  };

  const handleBlur = () => {
    if (props?.formik) {
      props.formik.setFieldTouched(props.label, true);
    }
  };
  return (
    <>
      <div className="input-group">
        <Select
          isSearchable={props.isSearchable ?? false}
          styles={customStyles}
          value={
            props?.formik ? props?.formik?.values[props?.label] : props?.value
          }
          isDisabled={props.isDisabled}
          onChange={handleChange}
          name={props.name}
          onMenuClose={handleBlur}
          placeholder={props.placeholder}
          required={props.required}
          options={props.options}
          isMulti={props.isMulti}
          menuPlacement={props.menuPlacement}
          classNamePrefix="react-select"
          theme={(theme) => ({
            ...theme,
            borderRadius: 0,
            colors: {
              ...theme.colors,
              primary25: '#ffe5d3',
              primary: 'rgb(251 146 60)'
            }
          })}
          getOptionLabel={props.getOptionLabel}
          getOptionValue={props.getOptionValue}
          components={{
            IndicatorSeparator: () => null
          }}
        />

        {/* {props?.errorFormik && (
          <p className="">
            <p className="">{props?.errorFormik?.errors[props?.label]}</p>
          </p>
        )}
        <p className="">{props?.formik?.errors[props?.label]}</p> */}
        {props.formik?.touched[props?.label] &&
          props.formik?.errors[props?.label] && (
            <p className="">{props?.formik?.errors[props?.label]}</p>
          )}
          {console.log(`props?.formik?.errors[props?.label]`, props.formik?.touched)}
      </div>
    </>
  );
}

export default SelectBox;
